import { Municipalities } from 'features/municipalities';
import { AppPage } from 'common/Layout';
import { homeBreadcrumbItem } from 'shared/UI/UIKit/Breadcrumbs';

const breadcrumbs = [
  homeBreadcrumbItem,
  {
    title: 'Муниципалитеты',
    url: '',
  },
];

export const MunicipalitiesPage = () => {
  return (
    <AppPage breadcrumbs={{ items: breadcrumbs }} documentTitle="Муниципалитеты">
      <Municipalities />
    </AppPage>
  );
};
